<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

// Servido estaticamente pelo Rails (public/), não é módulo do Vite. Precisa ser
// binding: `src="/..."` literal faz o compilador do Vue tentar resolver como
// import e o build quebra em "Rollup failed to resolve import".
const siteupIcon = '/brand-assets/siteup-icon.png';
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <img v-else v-bind="attrs" :src="siteupIcon" alt="" />
</template>
